import { createApp } from "vue";

import App from "./App.vue";

import "./assets/scss/main.scss";

import store from "./_store/store.js";
import router from "./router";

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const { authorize } = to.meta;
  const currentUser = store.getters["auth/getUser"];

  if (authorize) {
    if (!currentUser || !currentUser.username) {
      return next({ path: "/bruger/login", query: { returnUrl: to.path } });
    }
  }

  return next();
});

createApp(App).use(store).use(router).mount("#app");
